import {
  updateItemToFroomleRecommendation,
  updateItemToFroomleRecommendationScoped,
} from './froomle-item-helpers';
//todo add universal name for all items
const msntItemSelector = '.item-recommendation';

//todo items which need to be recommended
const msntSkeletonItemCls = 'item-recommendation-froomle';
const msntSkeletonItemSelector = `.${msntSkeletonItemCls}`;

const msntRecommendationContainerSelector = '[data-recommendations="true"]';
const nonScopedBlocksItemSelectors = {};

export const config = {
  ...window.jsVars?.froomle,

  // loadFirstWidgetASAP: window.dataLayer?.[0].pageType !== 'main',

  msntItemSelector,
  msntSkeletonItemSelector,
  msntSkeletonItemCls,
  msntRecommendationContainerSelector,

  nonScopedBlocksSelectors: {},
  nonScopedBlocksItemSelectors,

  scopedBlocksSelectors: {},
  scopedBlocksItemSelectors: {},
  initialRequestTimeout: 500000,

  hooks: {},

  user: {
    userId: localStorage.getItem('userId'),
    //todo if Editor
    isEditor: false,
  },
  updateItemToFroomleRecommendation,
  updateItemToFroomleRecommendationScoped,
};
